import { client } from '../apiConfig'

const listingLogicFunctionsAPI = () => {
  return client.get('/sourcing_rules/logic_functions/list')
}

export { listingLogicFunctionsAPI }
